module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BruSdh/tc-custom/9781427859204.jpg?1704456370806",
      "alt": "This image is the cover for the book Sword Princess Amaltea, Volume 1, Sword Princess Amaltea"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sword Princess Amaltea, Volume 1, Sword Princess Amaltea\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("We all know the way the story goes. The valiant prince goes on a perilous journey, kills a ferocious dragon, rescues a captive princess, earns his family's honor. But what if this time the prince… was a princess?")]), _c('p', [_vm._v("In a fairytale world where Queens rule and magic is power, Princess Amaltea is sent on the biggest quest of her life — to rescue a prince in need and fulfill her duties as a princess. Spoiled, prejudiced and sheltered from the world at large, Amaltea reluctantly sets out on her journey and finds her \"lad in distress\"… only to find out he's not so willing to join her.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Natalia Batista\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tokyopop Verlag\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0